import React from 'react';
import { useTranslation } from 'react-i18next';
import SalesIcon from '../../../../../shared/components/Icons/TicketType/Sales';
import PreorderIcon from '../../../../../shared/components/Icons/TicketType/Preorder';
import ElectronicIcon from '../../../../../shared/components/Icons/TicketType/Electronic';
import PaperIcon from '../../../../../shared/components/Icons/TicketType/Paper';
import * as Styled from './styled';
import SalesLandingIcon from '../../../../../shared/components/Icons/TicketType/SalesLandingIcon';
import PreorderLandingIcon from '../../../../../shared/components/Icons/TicketType/PreorderLandingIcon';
import ElectronicLandingIcon from '../../../../../shared/components/Icons/TicketType/ElectronicLandingIcon';
import PaperLandingIcon from '../../../../../shared/components/Icons/TicketType/PaperLandingIcon';

interface ITicketsType {
  announcementType: number;
  ticketType: number;
}

const TICKETS_TYPE_LABEL = {
  1: 'electronic_ticket',
  2: 'paper_ticket',
};

const ANNOUNCEMENT_TYPE_LABEL = {
  0: 'announcement_preorder',
  1: 'announcement_sales',
};

const getAnnouncementIcon = (announcementType: number, isLanding: boolean) => {
  if (announcementType === 0) {
    return isLanding ? PreorderLandingIcon : PreorderIcon;
  }
  if (announcementType === 1) {
    return isLanding ? SalesLandingIcon : SalesIcon;
  }
};
const getTicketIcon = (announcementType: number, isLanding: boolean) => {
  if (announcementType === 1) {
    return isLanding ? ElectronicLandingIcon : ElectronicIcon;
  }
  if (announcementType === 2) {
    return isLanding ? PaperLandingIcon : PaperIcon;
  }
};

export const TicketsType: React.FC<ITicketsType> = (props) => {
  const { Widget } = window;
  const { isLanding } = Widget.settings;

  const { announcementType, ticketType } = props;
  const { t } = useTranslation();
  const TicketIcon = getTicketIcon(ticketType, isLanding);
  const AnnouncementIcon = getAnnouncementIcon(announcementType, isLanding);

  return (
    <Styled.Icons>
      {TicketIcon && (
        <Styled.Icon>
          <TicketIcon />
          {t(TICKETS_TYPE_LABEL[ticketType])}
        </Styled.Icon>
      )}
      {AnnouncementIcon && (
        <Styled.Icon>
          <AnnouncementIcon />
          {t(ANNOUNCEMENT_TYPE_LABEL[announcementType])}
        </Styled.Icon>
      )}
    </Styled.Icons>
  );
};
